module.exports = __webpack_public_path__ + "static/media/square-logo.d021a291.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/square-logo.png
// module id = 7358
// module chunks = 4